/* フッターパララックス */
const imageWrappers = document.querySelectorAll('[data-js="parallax-wrapper"]');

imageWrappers.forEach((imageWrapper) => {
  const image = imageWrapper.querySelector('img');
  const endPosition = imageWrapper.dataset.parallaxEndPosition
    ? imageWrapper.dataset.parallaxEndPosition
    : 'bottom top';

  gsap.to(image, {
    scrollTrigger: {
      trigger: imageWrapper,
      start: 'top bottom',
      end: endPosition,
      scrub: 2,
      onUpdate: (self) => {
        const progress = self.progress;
        const imageHeight = image.clientHeight;
        const wrapperHeight = imageWrapper.clientHeight;
        const translateY = (wrapperHeight - imageHeight) * progress;
        gsap.set(image, { y: translateY });
      },
    },
  });
});

// 要素取得
const hamburger = document.querySelector('[data-manu="hamburger"]');
const drawer = document.querySelector('[data-manu="drawer"]');
const drawerHamburger = document.querySelector('[data-manu="drawer-hamburger"]');
const grayBackground = document.querySelector('[data-manu="gray-background"]');
const header = document.querySelector('header'); // ← 追加

// 開閉をひとまとめに
function toggleMenu(state) {
  const isOpen = state ?? !drawer.classList.contains('is-active-drawer');

  hamburger.classList.toggle('is-active-hamburger', isOpen);
  drawerHamburger.classList.toggle('is-active-drawer-hamburger', isOpen);
  drawer.classList.toggle('is-active-drawer', isOpen);
  grayBackground.classList.toggle('gray-background-active', isOpen);
}

// ハンバーガーをクリックした時
hamburger.addEventListener('click', () => toggleMenu());

// ドロワー内の×（または同じハンバーガー）をクリックした時
drawerHamburger.addEventListener('click', () => toggleMenu(false));

// header 以外をクリックしたら閉じる
document.addEventListener('click', (e) => {
  const clickedInsideHeader = header.contains(e.target);
  const menuIsOpen = drawer.classList.contains('is-active-drawer');

  if (menuIsOpen && !clickedInsideHeader) {
    toggleMenu(false);
  }
});

// スクロールでドロワーを閉じる
document.addEventListener('DOMContentLoaded', () => {
  const FAQS = document.querySelectorAll('.js-faq');
  const OPTS = { duration: 400, easing: 'ease-out', fill: 'both' };

  FAQS.forEach((faq) => {
    const summary = faq.querySelector('.js-faq-summary');
    const content = faq.querySelector('.js-faq-content');

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      /* すでに開いている → 閉じるアニメ */
      if (faq.open) {
        const start = content.offsetHeight; // 現在の高さ
        const anim = content.animate(
          [
            { height: `${start}px`, opacity: 1 },
            { height: 0, opacity: 0 },
          ],
          OPTS
        );
        anim.onfinish = () => {
          faq.open = false; // アニメ完了後に属性を外す
          content.style.height = ''; // 明示高さをリセット
        };
        return; // <= 早期 return
      }

      /* ─── 閉じている → 開くアニメ ─── */
      faq.open = true; // ① 一旦 open を付ける
      requestAnimationFrame(() => {
        // ② レイアウト確定を待つ
        const end = content.scrollHeight;
        content.style.height = '0px'; // 0 → end に向けてアニメ
        const anim = content.animate(
          [
            { height: 0, opacity: 0 },
            { height: `${end}px`, opacity: 1 },
          ],
          OPTS
        );
        anim.onfinish = () => {
          content.style.height = ''; // auto に戻す
        };
      });
    });
  });
});
